import { render, staticRenderFns } from "./GlobalHeader.vue?vue&type=template&id=2de20c62&scoped=true&"
import script from "./GlobalHeader.vue?vue&type=script&lang=js&"
export * from "./GlobalHeader.vue?vue&type=script&lang=js&"
import style0 from "./GlobalHeader.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./GlobalHeader.vue?vue&type=style&index=1&id=2de20c62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de20c62",
  null
  
)

export default component.exports